module.exports = __webpack_public_path__ + "img/factura.d1aedd86.png";